export default __webpack_public_path__ + "static/media/pinterest.91be8af9.png";